/**
 * Email formatting for news cards
 */

/**
 * Trim an email down to its local part plus the '@'.
 *
 * `apathi@inshortsapp.com` becomes `apathi@`. A card's footer has one line to
 * spare and the domain is the same for everyone on the team, so it earns none
 * of it - the part that identifies the person is what stays.
 *
 * Anything that is not an email - a display name, 'Unknown', a missing value -
 * is returned untouched, so callers can hand this whatever their fallback
 * chain produced.
 */
export const shortenEmail = (value) => {
  if (typeof value !== 'string') return value;

  const at = value.indexOf('@');
  return at === -1 ? value : value.slice(0, at + 1);
};
